import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/close_ic.svg';
const _withScopeId = n => (_pushScopeId("data-v-2994162d"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "icon" }),
    /*#__PURE__*/ _createElementVNode("div", { class: "font-28 tip" }, "搜索结果不满意？点此反馈")
], -1));
const _hoisted_2 = [
    _hoisted_1
];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title font-w500 font-36" }, "反馈", -1));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = { class: "searchInfo font-28 text-overflow gray-6" };
const _hoisted_9 = { class: "inpBox" };
const _hoisted_10 = { class: "btnBox flex font-w500" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
import { searchFeedBack } from '@/api/es';
import { ref, watch } from 'vue';
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    props: {
        searchText: {
            default: '',
            type: String
        },
        showFeed: {
            default: false,
            type: Boolean
        }
    },
    setup(__props) {
        const props = __props;
        let timeout = null;
        // 搜索反馈
        const feedBtnStatus = ref('none'); // none up long short
        watch(() => feedBtnStatus.value, n => {
            if (n == 'up' || n == 'long') {
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(() => {
                    feedBtnStatus.value = 'short';
                }, 2000);
            }
        });
        watch(() => props.showFeed, (n) => {
            if (n && feedBtnStatus.value == 'none') {
                feedBtnStatus.value = 'up';
            }
        });
        const status = ref('none'); // none up down
        // const conentClass = computed(() => {
        //   return {
        //     [`show${status.value}`]: status.value
        //   }
        // })
        let timer = null;
        const closeTip = () => {
            if (status.value == 'down') {
                return;
            }
            if (timer) {
                clearTimeout(timer);
            }
            feedContent.value = '';
            status.value = 'down';
            timer = setTimeout(() => {
                status.value = 'none';
            }, 300);
        };
        const feedContent = ref('');
        let loading = false;
        const feedBack = () => {
            if (!props.searchText) {
                return;
            }
            if (loading) {
                return;
            }
            loading = true;
            searchFeedBack({
                subject: props.searchText,
                content: feedContent.value
            }).then((res) => {
                loading = false;
                if (res.code == 200) {
                    Toast('反馈成功');
                    closeTip();
                }
            });
        };
        return (_ctx, _cache) => {
            const _component_van_field = _resolveComponent("van-field");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["feedBtn border-box", [`show_` + feedBtnStatus.value]]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (status.value = 'up'), ["stop"]))
                }, _hoisted_2, 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["feedWrapper", [`show-` + status.value]])
                }, [
                    _createElementVNode("div", {
                        class: "feedContentBox",
                        onClick: _withModifiers(closeTip, ["stop"])
                    }, [
                        _createElementVNode("div", {
                            class: "feedContent white-bg",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _hoisted_4,
                            _createElementVNode("div", {
                                class: "closeBtn",
                                onClick: _withModifiers(closeTip, ["stop"])
                            }, _hoisted_7, 8, _hoisted_5),
                            _createElementVNode("div", _hoisted_8, " | 搜索内容：" + _toDisplayString(props.searchText), 1),
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_van_field, {
                                    modelValue: feedContent.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((feedContent).value = $event)),
                                    rows: "3",
                                    maxlength: "200",
                                    autosize: "",
                                    type: "textarea",
                                    "show-word-limit": "",
                                    border: false,
                                    autofocus: "",
                                    placeholder: "请详细说说（选填）"
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", {
                                    class: "cancelBtn font-28 themeColor btn",
                                    onClick: _withModifiers(closeTip, ["stop"])
                                }, " 取消 ", 8, _hoisted_11),
                                _createElementVNode("div", {
                                    class: "submitBtn font-28 btn",
                                    onClick: _withModifiers(feedBack, ["stop"])
                                }, "确定", 8, _hoisted_12)
                            ])
                        ])
                    ], 8, _hoisted_3)
                ], 2)
            ]));
        };
    }
});
